module.exports = __webpack_public_path__ + "static/media/Digital_Glyph_White.889eff3b.svg";